var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择油站:" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "请选择",
                        clearable: ""
                      },
                      model: {
                        value: _vm.searchInfo.stationId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "stationId", $$v)
                        },
                        expression: "searchInfo.stationId"
                      }
                    },
                    _vm._l(_vm.stationOptions, function(item) {
                      return _c("el-option", {
                        key: item.ID,
                        attrs: { label: item.stationName, value: item.ID }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.activityName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "activityName", $$v)
                      },
                      expression: "searchInfo.activityName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.activityStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "activityStatus", $$v)
                        },
                        expression: "searchInfo.activityStatus"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { key: 1, attrs: { label: "启用", value: 1 } },
                        [_vm._v("启用")]
                      ),
                      _c(
                        "el-option",
                        { key: 2, attrs: { label: "禁用", value: 2 } },
                        [_vm._v("禁用")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "审核状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.auditStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "auditStatus", $$v)
                        },
                        expression: "searchInfo.auditStatus"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { key: 1, attrs: { label: "待审核", value: 1 } },
                        [_vm._v("待审核")]
                      ),
                      _c(
                        "el-option",
                        { key: 2, attrs: { label: "通过", value: 2 } },
                        [_vm._v("通过")]
                      ),
                      _c(
                        "el-option",
                        { key: 3, attrs: { label: "不通过", value: 3 } },
                        [_vm._v("不通过")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.onAdd }
                    },
                    [_vm._v("新增活动")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark"
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "row-dblclick": _vm.onRowdbclick
          }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", {
            attrs: { label: "活动编号", prop: "activityNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "活动名称", prop: "activityName" }
          }),
          _c("el-table-column", {
            attrs: { label: "开始时间", prop: "dateStart" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.dateStart)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "结束时间", prop: "dateEnd" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.dateEnd)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "活动状态", prop: "activityStatus" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.auditStatus == 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "warn", effect: "plain" } },
                          [_vm._v("待审核")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 3
                      ? _c(
                          "el-tag",
                          { attrs: { type: "error", effect: "plain" } },
                          [_vm._v("审核不通过")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2 && scope.row.activityStatus == 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "success", effect: "plain" } },
                          [_vm._v("已启用")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2 && scope.row.activityStatus == 2
                      ? _c(
                          "el-tag",
                          { attrs: { type: "error", effect: "plain" } },
                          [_vm._v("已禁用")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "300px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onView(scope.row)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    ),
                    scope.row.auditStatus == 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onUpdate(scope.row)
                              }
                            }
                          },
                          [_vm._v("变更")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 1
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onAudit(scope.row)
                              }
                            }
                          },
                          [_vm._v("审核")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onAble(scope.row)
                              }
                            }
                          },
                          [_vm._v("启用")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.onDisable(scope.row)
                              }
                            }
                          },
                          [_vm._v("禁用")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.onDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-paysuccess-activity-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 2 } }, [_vm._v(" ")]),
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "活动名称：" } },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.formData.activityName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "activityName",
                                          $$v
                                        )
                                      },
                                      expression: "formData.activityName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "活动时间：" } },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "datetimerange",
                                      align: "right",
                                      "unlink-panels": "",
                                      "range-separator": "至",
                                      "start-placeholder": "开始(含当天)",
                                      "end-placeholder": "结束(含当天)",
                                      format: "yyyy-MM-dd HH:mm:ss",
                                      "value-format": "yyyy-MM-dd HH:mm:ss"
                                    },
                                    model: {
                                      value: _vm.dateRangeValueArr,
                                      callback: function($$v) {
                                        _vm.dateRangeValueArr = $$v
                                      },
                                      expression: "dateRangeValueArr"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "活动油站:" } },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      model: {
                                        value: _vm.stationCheckAll,
                                        callback: function($$v) {
                                          _vm.stationCheckAll = $$v
                                        },
                                        expression: "stationCheckAll"
                                      }
                                    },
                                    [_vm._v("全选")]
                                  ),
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      model: {
                                        value: _vm.stationIdChecked,
                                        callback: function($$v) {
                                          _vm.stationIdChecked = $$v
                                        },
                                        expression: "stationIdChecked"
                                      }
                                    },
                                    _vm._l(_vm.stationOptions, function(item) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: item.ID,
                                          attrs: { label: item.ID }
                                        },
                                        [_vm._v(_vm._s(item.stationName))]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "活动油品:" } },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      model: {
                                        value: _vm.oilCodesCheckAll,
                                        callback: function($$v) {
                                          _vm.oilCodesCheckAll = $$v
                                        },
                                        expression: "oilCodesCheckAll"
                                      }
                                    },
                                    [_vm._v("全选")]
                                  ),
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      model: {
                                        value: _vm.oilCodesChecked,
                                        callback: function($$v) {
                                          _vm.oilCodesChecked = $$v
                                        },
                                        expression: "oilCodesChecked"
                                      }
                                    },
                                    _vm._l(_vm.oilCodesOptions, function(oil) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: oil.value,
                                          attrs: { label: oil.value }
                                        },
                                        [_vm._v(_vm._s(oil.label))]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "支付方式:" } },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      model: {
                                        value: _vm.payChannelCheckAll,
                                        callback: function($$v) {
                                          _vm.payChannelCheckAll = $$v
                                        },
                                        expression: "payChannelCheckAll"
                                      }
                                    },
                                    [_vm._v("全选")]
                                  ),
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      model: {
                                        value: _vm.payChannelChecked,
                                        callback: function($$v) {
                                          _vm.payChannelChecked = $$v
                                        },
                                        expression: "payChannelChecked"
                                      }
                                    },
                                    _vm._l(_vm.payChannelOptions, function(
                                      item
                                    ) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: item.payChannel,
                                          attrs: { label: item.payChannel }
                                        },
                                        [_vm._v(_vm._s(item.cnName))]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.payChannelChecked.filter(function(item) {
                        return item != 1002
                      }).length > 0
                        ? _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "会员群组:" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value: _vm.userGroupCheckAll,
                                            callback: function($$v) {
                                              _vm.userGroupCheckAll = $$v
                                            },
                                            expression: "userGroupCheckAll"
                                          }
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value: _vm.userGroupChecked,
                                            callback: function($$v) {
                                              _vm.userGroupChecked = $$v
                                            },
                                            expression: "userGroupChecked"
                                          }
                                        },
                                        _vm._l(_vm.userGroupOptions, function(
                                          item
                                        ) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: item.ID,
                                              attrs: { label: item.ID }
                                            },
                                            [_vm._v(_vm._s(item.groupName))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.payChannelChecked.indexOf(1002) > -1
                        ? _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "大客户群组:" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value: _vm.svcGroupCheckAll,
                                            callback: function($$v) {
                                              _vm.svcGroupCheckAll = $$v
                                            },
                                            expression: "svcGroupCheckAll"
                                          }
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          on: {
                                            change:
                                              _vm.handleCheckedSvcGroupChange
                                          },
                                          model: {
                                            value: _vm.svcGroupChecked,
                                            callback: function($$v) {
                                              _vm.svcGroupChecked = $$v
                                            },
                                            expression: "svcGroupChecked"
                                          }
                                        },
                                        _vm._l(_vm.svcGroupOptions, function(
                                          item
                                        ) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: item.groupId,
                                              attrs: { label: item.groupId }
                                            },
                                            [_vm._v(_vm._s(item.groupName))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "限制金额：" } },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "small" },
                                      model: {
                                        value: _vm.formData.limitMoneyType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "limitMoneyType",
                                            $$v
                                          )
                                        },
                                        expression: "formData.limitMoneyType"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("油品金额满")
                                      ]),
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("整单满")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: { label: "支付成功赠送：" }
                                },
                                _vm._l(_vm.formData.giveTicketList, function(
                                  item,
                                  index
                                ) {
                                  return _c(
                                    "el-row",
                                    {
                                      staticClass: "ticket-form-item",
                                      staticStyle: { "margin-bottom": "22px" }
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 6 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "满：",
                                                    prop:
                                                      "giveTicketList." +
                                                      index +
                                                      ".limitMoney"
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    model: {
                                                      value: item.limitMoney,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "limitMoney",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.limitMoney"
                                                    }
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "bairun-form-item-label-suffix"
                                                    },
                                                    [_vm._v("元")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._l(
                                        _vm.formData.giveTicketList[index]
                                          .tickets,
                                        function(tkItem, tkIndex) {
                                          return _c(
                                            "el-row",
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 6 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "券编号",
                                                        prop:
                                                          "giveTicketList." +
                                                          index +
                                                          ".tickets." +
                                                          tkIndex +
                                                          ".ticketRuleNo"
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        model: {
                                                          value:
                                                            tkItem.ticketRuleNo,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              tkItem,
                                                              "ticketRuleNo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "tkItem.ticketRuleNo"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 1 } },
                                                [_vm._v(" ")]
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 6 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "数量",
                                                        prop:
                                                          "giveTicketList." +
                                                          index +
                                                          ".tickets." +
                                                          tkIndex +
                                                          ".num"
                                                      }
                                                    },
                                                    [
                                                      _c("el-input-number", {
                                                        model: {
                                                          value: tkItem.num,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              tkItem,
                                                              "num",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "tkItem.num"
                                                        }
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "bairun-form-item-label-suffix"
                                                        },
                                                        [_vm._v("张")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "是否可每天扫码：" } },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "small" },
                                      model: {
                                        value: _vm.formData.isRepeat,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "isRepeat",
                                            $$v
                                          )
                                        },
                                        expression: "formData.isRepeat"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("可以")
                                      ]),
                                      _c("el-radio", { attrs: { label: 0 } }, [
                                        _vm._v("不可以")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "每天最高扫的次数：" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请输入次数"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.formData.perdayLimit = Number(
                                          _vm.formData.perdayLimit
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.perdayLimit,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "perdayLimit",
                                          $$v
                                        )
                                      },
                                      expression: "formData.perdayLimit "
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "审核结果：" } },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "small" },
                                      model: {
                                        value: _vm.formData.auditStatus,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "auditStatus",
                                            $$v
                                          )
                                        },
                                        expression: "formData.auditStatus"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("待审核")
                                      ]),
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("通过")
                                      ]),
                                      _c("el-radio", { attrs: { label: 3 } }, [
                                        _vm._v("不通过")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "审核意见：" } },
                                [
                                  _c("el-input", {
                                    attrs: { type: "textarea", rows: "5" },
                                    model: {
                                      value: _vm.formData.auditRemark,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "auditRemark",
                                          $$v
                                        )
                                      },
                                      expression: "formData.auditRemark"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-col", { attrs: { span: 2 } }, [_vm._v(" ")])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.addDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-paysuccess-activity-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.addDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 2 } }, [_vm._v(" ")]),
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: {
                        model: _vm.formData,
                        rules: _vm.getRule,
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "活动名称：",
                                    prop: "activityName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入" },
                                    on: {
                                      input: function($event) {
                                        return _vm.inputChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.activityName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "activityName",
                                          $$v
                                        )
                                      },
                                      expression: "formData.activityName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "活动时间：",
                                    prop: "dateRangeValueArr"
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "datetimerange",
                                      align: "right",
                                      "unlink-panels": "",
                                      "range-separator": "至",
                                      "start-placeholder": "开始(含当天)",
                                      "end-placeholder": "结束(含当天)",
                                      format: "yyyy-MM-dd HH:mm:ss",
                                      "value-format": "yyyy-MM-dd HH:mm:ss"
                                    },
                                    model: {
                                      value: _vm.dateRangeValueArr,
                                      callback: function($$v) {
                                        _vm.dateRangeValueArr = $$v
                                      },
                                      expression: "dateRangeValueArr"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "活动油站:",
                                    prop: "stationIdChecked"
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      on: {
                                        change: _vm.handleStationCheckAllChange
                                      },
                                      model: {
                                        value: _vm.stationCheckAll,
                                        callback: function($$v) {
                                          _vm.stationCheckAll = $$v
                                        },
                                        expression: "stationCheckAll"
                                      }
                                    },
                                    [_vm._v("全选")]
                                  ),
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      on: {
                                        change: _vm.handleCheckedStationChange
                                      },
                                      model: {
                                        value: _vm.stationIdChecked,
                                        callback: function($$v) {
                                          _vm.stationIdChecked = $$v
                                        },
                                        expression: "stationIdChecked"
                                      }
                                    },
                                    _vm._l(_vm.stationOptions, function(item) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: item.ID,
                                          attrs: { label: item.ID }
                                        },
                                        [_vm._v(_vm._s(item.stationName))]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "活动油品:",
                                    prop: "oilCodesChecked"
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      on: {
                                        change: _vm.handleOilCheckAllChange
                                      },
                                      model: {
                                        value: _vm.oilCodesCheckAll,
                                        callback: function($$v) {
                                          _vm.oilCodesCheckAll = $$v
                                        },
                                        expression: "oilCodesCheckAll"
                                      }
                                    },
                                    [_vm._v("全选")]
                                  ),
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      on: {
                                        change: _vm.handleCheckedOilCodesChange
                                      },
                                      model: {
                                        value: _vm.oilCodesChecked,
                                        callback: function($$v) {
                                          _vm.oilCodesChecked = $$v
                                        },
                                        expression: "oilCodesChecked"
                                      }
                                    },
                                    _vm._l(_vm.oilCodesOptions, function(oil) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: oil.value,
                                          attrs: { label: oil.value }
                                        },
                                        [_vm._v(_vm._s(oil.label))]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "支付方式:",
                                    prop: "payChannelChecked"
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      on: {
                                        change:
                                          _vm.handlePayChannelCheckAllChange
                                      },
                                      model: {
                                        value: _vm.payChannelCheckAll,
                                        callback: function($$v) {
                                          _vm.payChannelCheckAll = $$v
                                        },
                                        expression: "payChannelCheckAll"
                                      }
                                    },
                                    [_vm._v("全选")]
                                  ),
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      on: {
                                        change:
                                          _vm.handleCheckedPayChannelChange
                                      },
                                      model: {
                                        value: _vm.payChannelChecked,
                                        callback: function($$v) {
                                          _vm.payChannelChecked = $$v
                                        },
                                        expression: "payChannelChecked"
                                      }
                                    },
                                    _vm._l(_vm.payChannelOptions, function(
                                      item
                                    ) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: item.payChannel,
                                          attrs: { label: item.payChannel }
                                        },
                                        [_vm._v(_vm._s(item.cnName))]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "会员群组:",
                                    prop: "userGroupChecked"
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !(
                                          _vm.payChannelChecked.filter(function(
                                            item
                                          ) {
                                            return item != 1002
                                          }).length > 0
                                        )
                                      },
                                      on: {
                                        change:
                                          _vm.handleUserGroupCheckAllChange
                                      },
                                      model: {
                                        value: _vm.userGroupCheckAll,
                                        callback: function($$v) {
                                          _vm.userGroupCheckAll = $$v
                                        },
                                        expression: "userGroupCheckAll"
                                      }
                                    },
                                    [_vm._v("全选")]
                                  ),
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      attrs: {
                                        disabled: !(
                                          _vm.payChannelChecked.filter(function(
                                            item
                                          ) {
                                            return item != 1002
                                          }).length > 0
                                        )
                                      },
                                      on: {
                                        change: _vm.handleCheckedUserGroupChange
                                      },
                                      model: {
                                        value: _vm.userGroupChecked,
                                        callback: function($$v) {
                                          _vm.userGroupChecked = $$v
                                        },
                                        expression: "userGroupChecked"
                                      }
                                    },
                                    _vm._l(_vm.userGroupOptions, function(
                                      item
                                    ) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: item.ID,
                                          attrs: { label: item.ID }
                                        },
                                        [_vm._v(_vm._s(item.groupName))]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "大客户群组:",
                                    prop: "svcGroupChecked"
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: !(
                                          _vm.payChannelChecked.indexOf(1002) >
                                          -1
                                        )
                                      },
                                      on: {
                                        change: _vm.handleSvcGroupCheckAllChange
                                      },
                                      model: {
                                        value: _vm.svcGroupCheckAll,
                                        callback: function($$v) {
                                          _vm.svcGroupCheckAll = $$v
                                        },
                                        expression: "svcGroupCheckAll"
                                      }
                                    },
                                    [_vm._v("全选")]
                                  ),
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      attrs: {
                                        disabled: !(
                                          _vm.payChannelChecked.indexOf(1002) >
                                          -1
                                        )
                                      },
                                      on: {
                                        change: _vm.handleCheckedSvcGroupChange
                                      },
                                      model: {
                                        value: _vm.svcGroupChecked,
                                        callback: function($$v) {
                                          _vm.svcGroupChecked = $$v
                                        },
                                        expression: "svcGroupChecked"
                                      }
                                    },
                                    _vm._l(_vm.svcGroupOptions, function(item) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: item.groupId,
                                          attrs: { label: item.groupId }
                                        },
                                        [_vm._v(_vm._s(item.groupName))]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "限制金额：",
                                    prop: "limitMoneyType"
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "small" },
                                      model: {
                                        value: _vm.formData.limitMoneyType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "limitMoneyType",
                                            $$v
                                          )
                                        },
                                        expression: "formData.limitMoneyType"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("油品金额满")
                                      ]),
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("整单满")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: { label: "支付成功赠送：" }
                                },
                                _vm._l(_vm.formData.giveTicketList, function(
                                  item,
                                  index
                                ) {
                                  return _c(
                                    "el-row",
                                    {
                                      staticClass: "ticket-form-item",
                                      staticStyle: { "margin-bottom": "22px" }
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 6 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "满：",
                                                    prop:
                                                      "giveTicketList." +
                                                      index +
                                                      ".limitMoney"
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.type == "update",
                                                      clearable: "",
                                                      placeholder: "请输入金额"
                                                    },
                                                    model: {
                                                      value: item.limitMoney,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "limitMoney",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.limitMoney"
                                                    }
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "bairun-form-item-label-suffix"
                                                    },
                                                    [_vm._v("元")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c("el-col", { attrs: { span: 7 } }, [
                                            _vm._v(" ")
                                          ]),
                                          _vm.type != "update"
                                            ? _c(
                                                "el-col",
                                                {
                                                  staticClass:
                                                    "btn-tool-balancrange",
                                                  attrs: { span: 1 }
                                                },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          staticClass:
                                                            "btn-tool-balancrange",
                                                          attrs: {
                                                            type: "primary"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.onDeleteItem(
                                                                index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("-")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.type != "update"
                                            ? _c(
                                                "el-col",
                                                {
                                                  staticClass:
                                                    "btn-tool-balancrange",
                                                  attrs: { span: 1 }
                                                },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.onAddItem(
                                                                index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("+")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._l(
                                        _vm.formData.giveTicketList[index]
                                          .tickets,
                                        function(tkItem, tkIndex) {
                                          return _c(
                                            "el-row",
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 6 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "券编号",
                                                        prop:
                                                          "giveTicketList." +
                                                          index +
                                                          ".tickets." +
                                                          tkIndex +
                                                          ".ticketRuleNo"
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled:
                                                            _vm.type ==
                                                            "update",
                                                          clearable: "",
                                                          placeholder:
                                                            "输入券编号"
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            return _vm.getTicketDetail(
                                                              tkItem
                                                            )
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            tkItem.ticketRuleNo,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              tkItem,
                                                              "ticketRuleNo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "tkItem.ticketRuleNo"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 1 } },
                                                [_vm._v(" ")]
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 6 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "数量",
                                                        prop:
                                                          "giveTicketList." +
                                                          index +
                                                          ".tickets." +
                                                          tkIndex +
                                                          ".num"
                                                      }
                                                    },
                                                    [
                                                      _c("el-input-number", {
                                                        attrs: {
                                                          disabled:
                                                            _vm.type ==
                                                            "update",
                                                          clearable: "",
                                                          placeholder:
                                                            "请输入张数",
                                                          min: 1
                                                        },
                                                        model: {
                                                          value: tkItem.num,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              tkItem,
                                                              "num",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "tkItem.num"
                                                        }
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "bairun-form-item-label-suffix"
                                                        },
                                                        [_vm._v("张")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm.type != "update"
                                                ? _c(
                                                    "el-col",
                                                    {
                                                      staticClass:
                                                        "btn-tool-balancrange",
                                                      attrs: { span: 1 }
                                                    },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        [
                                                          _c(
                                                            "el-button",
                                                            {
                                                              staticClass:
                                                                "btn-tool-balancrange",
                                                              attrs: {
                                                                type: "primary"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.onDeleteTicket(
                                                                    index,
                                                                    tkIndex
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("-")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.type != "update"
                                                ? _c(
                                                    "el-col",
                                                    {
                                                      staticClass:
                                                        "btn-tool-balancrange",
                                                      attrs: { span: 1 }
                                                    },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        [
                                                          _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                type: "primary"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.onAddTicket(
                                                                    index,
                                                                    tkIndex
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("+")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "是否可每天扫码：" } },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "small" },
                                      model: {
                                        value: _vm.formData.isRepeat,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "isRepeat",
                                            $$v
                                          )
                                        },
                                        expression: "formData.isRepeat"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("可以")
                                      ]),
                                      _c("el-radio", { attrs: { label: 0 } }, [
                                        _vm._v("不可以")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "每天最高扫的次数：" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请输入次数"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.formData.perdayLimit = Number(
                                          _vm.formData.perdayLimit
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.perdayLimit,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "perdayLimit",
                                          $$v
                                        )
                                      },
                                      expression: "formData.perdayLimit "
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-col", { attrs: { span: 2 } }, [_vm._v(" ")])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("提 交")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.auditDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-audit bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.auditDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 4 } }, [_vm._v(" ")]),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "审核结果：",
                                    prop: "auditStatus"
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "small" },
                                      model: {
                                        value: _vm.formData.auditStatus,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "auditStatus",
                                            $$v
                                          )
                                        },
                                        expression: "formData.auditStatus"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("通过")
                                      ]),
                                      _c("el-radio", { attrs: { label: 3 } }, [
                                        _vm._v("不通过")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "审核意见：",
                                    prop: "auditRemark"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入",
                                      rows: "5"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.inputChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.auditRemark,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "auditRemark",
                                          $$v
                                        )
                                      },
                                      expression: "formData.auditRemark"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-col", { attrs: { span: 4 } }, [_vm._v(" ")])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("提 交")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }